export enum TERM_ROUTES {
  QUOTE = "/quote/term-insurance/term-quote",
  POLICY_DETAILS = "/term-policy-details",
  BASIC_DETAILS = "basic-details",
  RIDERS_BENEFITS = "riders-benefits",
}
